export const copywrite = {
  main_title: "Eduwisata Lebah Madu Tanjung Leban",
  description: [
    //eslint-disable-next-line
    "Eduwisata Lebah Madu Tanjung Leban, sebuah inisiatif berkelanjutan yang digagas oleh \
    PT Kilang Pertamina Internasional Refinery Unit II, hadir sebagai perwujudan nyata \
    dari tanggung jawab sosial perusahaan. Terletak di kawasan hutan gambut Sungai Pakning, \
    eduwisata ini menawarkan pengalaman unik bagi pengunjung untuk mengenal lebih \
    dekat kehidupan lebah kelulut atau stingless bee. Sebagai salah satu jenis lebah \
    tanpa sengat, kelulut memiliki peran penting dalam menjaga keseimbangan ekosistem. \
    Melalui budidaya lebah kelulut yang ramah lingkungan, Pertamina tidak hanya berkontribusi \
    pada pelestarian alam, tetapi juga memberikan nilai tambah bagi masyarakat sekitar.",
    //eslint-disable-next-line
    "Selain menjadi pusat edukasi, eduwisata ini juga berfungsi sebagai sarana pemberdayaan \
    masyarakat. Dengan melibatkan masyarakat setempat dalam pengelolaan eduwisata, Pertamina \
    turut mendorong pertumbuhan ekonomi di wilayah tersebut. Pengunjung yang datang \
    ke eduwisata tidak hanya dapat belajar tentang kehidupan lebah kelulut, tetapi \
    juga dapat menikmati produk-produk olahan madu kelulut yang dihasilkan oleh masyarakat. \
    Hal ini diharapkan dapat meningkatkan pendapatan masyarakat dan meningkatkan \
    taraf hidup mereka.",
    //eslint-disable-next-line
    "Keberadaan Eduwisata Lebah Madu Tanjung Leban juga memberikan kontribusi positif terhadap penilaian \
    PROPER (Program Penilaian Peringkat Kinerja Perusahaan). Program ini menunjukkan \
    komitmen Pertamina dalam menjalankan bisnis yang berkelanjutan dan bertanggung \
    jawab terhadap lingkungan. Dengan melestarikan hutan gambut dan membudidayakan \
    lebah kelulut, Pertamina turut berkontribusi dalam mengurangi emisi gas rumah \
    kaca dan menjaga keanekaragaman hayati.",
    //eslint-disable-next-line
    "Eduwisata Lebah Madu Tanjung Leban bukan hanya sekadar tempat wisata, tetapi juga merupakan sebuah \
    laboratorium alam yang hidup. Di sini, pengunjung dapat belajar tentang pentingnya \
    menjaga keseimbangan ekosistem dan peran serangga penyerbuk dalam kehidupan manusia. \
    Dengan demikian, eduwisata ini diharapkan dapat menginspirasi generasi muda untuk \
    lebih peduli terhadap lingkungan dan ikut serta dalam upaya pelestarian alam.",
  ],

  flora_table_title:
    "Keanekaragaman Hayati Program Eduwisata Lebah Madu Tanjung Leban",
  bird_table_title:
    "Jumlah spesies Burung di Eduwisata Lebah Madu Tanjung Leban",
  mammals_table_title:
    "Jumlah spesies Mamalia di Eduwisata Lebah Madu Tanjung Leban",
  herpetofauna_table_title:
    "Jumlah spesies Herpetofauna di Eduwisata Lebah Madu Tanjung Leban",
  dragonfly_table_title:
    "Jumlah spesies Capung di Eduwisata Lebah Madu Tanjung Leban",
  butterfly_table_title:
    "Jumlah spesies Kupu-kupu di Eduwisata Lebah Madu Tanjung Leban",
};

export const flora = [
  {
    "No": 1,
    "spesies": "Abelmoschus esculentus",
    "nama_lokal": "Okra",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 2,
    "spesies": "Albizia chinensis",
    "nama_lokal": "Sengon",
    "y2024": "",
    "y2025": 2
  },
  {
    "No": 3,
    "spesies": "Anonna muricata",
    "nama_lokal": "Sirsak",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 4,
    "spesies": "Aquilaria Malaccensis",
    "nama_lokal": "Gaharu",
    "y2024": 17,
    "y2025": 17
  },
  {
    "No": 5,
    "spesies": "Areca catechu",
    "nama_lokal": "Pinang",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 6,
    "spesies": "Artocarpus heterophyllus",
    "nama_lokal": "Nangka",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 7,
    "spesies": "Asplenium nidus",
    "nama_lokal": "Paku sarang burung",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 8,
    "spesies": "Averrhoa bilimbi",
    "nama_lokal": "Belimbing wuluh",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 9,
    "spesies": "Bougainvillea glabra",
    "nama_lokal": "Bougenvile",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 10,
    "spesies": "Catharanthus roseus",
    "nama_lokal": "Tapak dara",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 11,
    "spesies": "Citrus hystrix",
    "nama_lokal": "Jeruk purut",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 12,
    "spesies": "Citrus sinensis",
    "nama_lokal": "Jeruk",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 13,
    "spesies": "Cocos nucifera",
    "nama_lokal": "Kelapa",
    "y2024": 10,
    "y2025": 10
  },
  {
    "No": 14,
    "spesies": "Durio zibethinus",
    "nama_lokal": "Durian",
    "y2024": 8,
    "y2025": 8
  },
  {
    "No": 15,
    "spesies": "Elaeis guineensis",
    "nama_lokal": "Sawit",
    "y2024": 9,
    "y2025": 9
  },
  {
    "No": 16,
    "spesies": "Etlingera elianor",
    "nama_lokal": "Kecombrang",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 17,
    "spesies": "Garcinia mangostana",
    "nama_lokal": "Manggis",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 18,
    "spesies": "Hibiscus rosa x sinensis",
    "nama_lokal": "Hibiscus",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 19,
    "spesies": "Lansium domesticum",
    "nama_lokal": "Duku",
    "y2024": 21,
    "y2025": 21
  },
  {
    "No": 20,
    "spesies": "Macaranga sp.",
    "nama_lokal": "Mahang",
    "y2024": 22,
    "y2025": 22
  },
  {
    "No": 21,
    "spesies": "Manilkara zapota",
    "nama_lokal": "Sawo",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 22,
    "spesies": "Melastoma malabathricum",
    "nama_lokal": "Melastoma",
    "y2024": 8,
    "y2025": 8
  },
  {
    "No": 23,
    "spesies": "Melicope ptelofolia",
    "nama_lokal": "Tenggek burung",
    "y2024": 5,
    "y2025": 5
  },
  {
    "No": 24,
    "spesies": "Monstera sp.",
    "nama_lokal": "Monstera",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 25,
    "spesies": "Muntingia calabura",
    "nama_lokal": "Talok",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 26,
    "spesies": "Musa paradisiaca",
    "nama_lokal": "Pisang",
    "y2024": 23,
    "y2025": 23
  },
  {
    "No": 27,
    "spesies": "Nephelium lappaceum",
    "nama_lokal": "Rambutan",
    "y2024": 32,
    "y2025": 32
  },
  {
    "No": 28,
    "spesies": "Parkia speciosa",
    "nama_lokal": "Petai",
    "y2024": 19,
    "y2025": 19
  },
  {
    "No": 29,
    "spesies": "Persea americana",
    "nama_lokal": "Alpukat",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 30,
    "spesies": "Philodendron sp.",
    "nama_lokal": "-",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 31,
    "spesies": "Pithecellobium jiringa",
    "nama_lokal": "Jengkol",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 32,
    "spesies": "Pluchea indica",
    "nama_lokal": "Beluntas",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 33,
    "spesies": "Pometia pinnata",
    "nama_lokal": "Matoa",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 34,
    "spesies": "Saraca indica",
    "nama_lokal": "Asoka",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 35,
    "spesies": "Solanum melongena",
    "nama_lokal": "Terong",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 36,
    "spesies": "Solanum torvum",
    "nama_lokal": "Takokak",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 37,
    "spesies": "Syzygium aqueum",
    "nama_lokal": "Jambu air",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 38,
    "spesies": "Syzygium malaccense",
    "nama_lokal": "Jambu gelas",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 39,
    "spesies": "Syzygium polyanthum",
    "nama_lokal": "Salam",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 40,
    "spesies": "Tetracera indica",
    "nama_lokal": "Mempelas",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 41,
    "spesies": "Trema orientalis",
    "nama_lokal": "Anggrung",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 42,
    "spesies": "Vitex pinnata",
    "nama_lokal": "Leban",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 43,
    "spesies": "Wrightia religiosa",
    "nama_lokal": "Anting putri",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 44,
    "spesies": "Xanthostemon chrysanthus",
    "nama_lokal": "Santos",
    "y2024": 86,
    "y2025": 86
  }
];

export const birds = [
  {
    "No": 1,
    "spesies": "Acridotheres javanicus",
    "nama_lokal": "Kerak kerbau",
    "y2024": 3,
    "y2025": 5
  },
  {
    "No": 2,
    "spesies": "Aegithina tiphia",
    "nama_lokal": "Cipoh kacat",
    "y2024": 2,
    "y2025": 4
  },
  {
    "No": 3,
    "spesies": "Aethopyga siparaja",
    "nama_lokal": "Burung madu sepah-raja",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 4,
    "spesies": "Anthreptes malacensis",
    "nama_lokal": "Burung madu kelapa",
    "y2024": 6,
    "y2025": 8
  },
  {
    "No": 5,
    "spesies": "Collocalia affinis",
    "nama_lokal": "Walet-sapi jari-bulu",
    "y2024": 0,
    "y2025": 10
  },
  {
    "No": 6,
    "spesies": "Collocalia esculenta",
    "nama_lokal": "Walet sapi",
    "y2024": 8,
    "y2025": 8
  },
  {
    "No": 7,
    "spesies": "Collocalia fuciphaga",
    "nama_lokal": "Walet sarang putih",
    "y2024": 6,
    "y2025": 6
  },
  {
    "No": 8,
    "spesies": "Corvus macrorhynchos",
    "nama_lokal": "Gagak kampung",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 9,
    "spesies": "Dendrocopos moluccensis",
    "nama_lokal": "Caladi tilik",
    "y2024": 3,
    "y2025": 5
  },
  {
    "No": 10,
    "spesies": "Eurystomus orientalis",
    "nama_lokal": "Tiong lampu biasa",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 11,
    "spesies": "Lalage nigra",
    "nama_lokal": "Kapasan kemiri",
    "y2024": 1,
    "y2025": 2
  },
  {
    "No": 12,
    "spesies": "Lonchura atricapilla",
    "nama_lokal": "Bondol coklat",
    "y2024": 8,
    "y2025": 10
  },
  {
    "No": 13,
    "spesies": "Lonchura maja",
    "nama_lokal": "Bondol haji",
    "y2024": 10,
    "y2025": 11
  },
  {
    "No": 14,
    "spesies": "Passer montanus",
    "nama_lokal": "Burung gereja eurasia",
    "y2024": 8,
    "y2025": 10
  },
  {
    "No": 15,
    "spesies": "Pycnonotus aurigaster",
    "nama_lokal": "Kutilang",
    "y2024": 4,
    "y2025": 10
  },
  {
    "No": 16,
    "spesies": "Pycnonotus goiavier",
    "nama_lokal": "Merbah cerucuk",
    "y2024": 5,
    "y2025": 8
  },
  {
    "No": 17,
    "spesies": "Todirhamphus chloris",
    "nama_lokal": "Cekakak sungai",
    "y2024": 1,
    "y2025": 2
  },
  {
    "No": 18,
    "spesies": "Treron vernans",
    "nama_lokal": "Punai gading",
    "y2024": 0,
    "y2025": 3
  }
];

export const mammals = [
  {
    "No": 1,
    "spesies": "Callosciurus notatus",
    "nama_lokal": "Bajing Kelapa",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 2,
    "spesies": "Helarctos malayanus",
    "nama_lokal": "Beruang madu",
    "y2024": "",
    "y2025": 1
  },
  {
    "No": 3,
    "spesies": "Macaca fascicularis",
    "nama_lokal": "Monyet Ekor Panjang",
    "y2024": 20,
    "y2025": 20
  },
  {
    "No": 4,
    "spesies": "Neofelis diardi",
    "nama_lokal": "Macan dahan sumatra",
    "y2024": "",
    "y2025": 1
  },
  {
    "No": 5,
    "spesies": "Presbytis melalophos",
    "nama_lokal": "Lutung Simpai Hitam Sumatera",
    "y2024": 8,
    "y2025": 8
  }
];

export const herpetofauna = [
  {
    "No": 1,
    "spesies": "Eutropis multifasciata",
    "nama_lokal": "Bengkarung",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 2,
    "spesies": "Fejervarya sp.",
    "nama_lokal": "Kodok sawah",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 3,
    "spesies": "Bronchocela jubata",
    "nama_lokal": "Bunglon surai",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 4,
    "spesies": "Draco sp.",
    "nama_lokal": "Cekibar",
    "y2024": 0,
    "y2025": 1
  }
];

export const dragonfly = [
  {
    "No": 1,
    "spesies": "Brachydiplax chalybea",
    "nama_lokal": "Capung‐sambar dada-karat",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 2,
    "spesies": "Camacinia gigantea",
    "nama_lokal": "Capung-jala raja",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 3,
    "spesies": "Ictinogomphus decoratus",
    "nama_lokal": "Capung-loreng tombak",
    "y2024": 1,
    "y2025": 4
  },
  {
    "No": 4,
    "spesies": "Nannophya pygmaea",
    "nama_lokal": "-",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 5,
    "spesies": "Orthetrum sabina",
    "nama_lokal": "Capung-sambar hijau",
    "y2024": 3,
    "y2025": 6
  },
  {
    "No": 6,
    "spesies": "Rhyothemis phyllis",
    "nama_lokal": "Capung-lebah garis-kuning",
    "y2024": 0,
    "y2025": 1
  }
];

export const butterfly = [
  {
    "No": 1,
    "spesies": "Acraea terpsicore",
    "nama_lokal": "Kupu-kupu coster jingga",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 2,
    "spesies": "Danaus melanippus",
    "nama_lokal": "Kupu-kupu macan putih",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 3,
    "spesies": "Eurema sp.",
    "nama_lokal": "Kupu-kupu belerang",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 4,
    "spesies": "Hypolycaena sp,",
    "nama_lokal": "Kupu-kupu biru kecil",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 5,
    "spesies": "Junonia orithya",
    "nama_lokal": "Kupu-kupu solek biru",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 6,
    "spesies": "Papilio demoleus",
    "nama_lokal": "Kupu-kupu jeruk",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 7,
    "spesies": "Papilio sp.",
    "nama_lokal": "Kupu-kupu ekor layang",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 8,
    "spesies": "Prosotas dubiosa",
    "nama_lokal": "Kupu-kupu kepak kuntul",
    "y2024": 0,
    "y2025": 2
  }
];

export const data_count = {
  flora: [
    { x: "2024", y: 308 },
    { x: "2025", y: 310 },
  ],
  birds: [
    { x: "2024", y: 66 },
    { x: "2025", y: 106 },
  ],
  mammals: [
    { x: "2024", y: 30 },
    { x: "2025", y: 32 },
  ],
  herpetofauna: [
    { x: "2024", y: 2 },
    { x: "2025", y: 4 },
  ],
  dragonfly: [
    { x: "2024", y: 5 },
    { x: "2025", y: 16 },
  ],
  butterfly: [
    { x: "2024", y: 5 },
    { x: "2025", y: 10 },
  ],
};

export const total_species = {
  flora: [{ x: "2023", y: 72, yOffset: -25 }],
  birds: [
    { x: "2022", y: 22, yOffset: -25 },
    { x: "2023", y: 22, yOffset: -25 },
  ],
};

export const hre_index = {
  flora: [
    { x: "2024", h: 2.77, r: 7.33, e: 0.74, yOffset: 20 },
    { x: "2025", h: 3.19, r: 8.08, e: 0.81, yOffset: 20 },
  ],
  birds: [
    { x: "2024", h: 2.43, r: 3.1, e: 2.43, yOffset: 20 },
    { x: "2025", h: 2.81, r: 4.53, e: 0.90, yOffset: 20 },
  ],
  mammals: [
    { x: "2024", h: 0.8, r: 0.59, e: 0.73, yOffset: 20 },
    { x: "2025", h: 1.24, r: 1.23, e: 0.69, yOffset: 20 },
  ],
  herpetofauna: [
    { x: "2024", h: 0.69, r: 1.0, e: 1.44, yOffset: -20 },
    { x: "2025", h: 1.68, r: 2.28, e: 0.94, yOffset: -20 },
  ],
  dragonfly: [
    { x: "2024", h: 0.95, r: 1.24, e: 0.87, yOffset: -20 },
    { x: "2025", h: 1.67, r: 2.08, e: 0.86, yOffset: -20 },
  ],
  butterfly: [
    { x: "2024", h: 1.61, r: 0.62, e: 2.32, yOffset: -20 },
    { x: "2025", h: 1.93, r: 2.58, e: 0.93, yOffset: -20 },
  ],
};
